import { cn } from "@/lib/cn";

interface SegmentedOption<T extends string> {
	value: T;
	label: string;
}

interface SegmentedProps<T extends string> {
	options: SegmentedOption<T>[];
	value: T;
	onChange: (value: T) => void;
	className?: string;
}

export function Segmented<T extends string>({
	options,
	value,
	onChange,
	className,
}: SegmentedProps<T>) {
	return (
		<div className={cn("seg", className)}>
			{options.map((o) => (
				<button
					key={o.value}
					className={value === o.value ? "on" : ""}
					onClick={() => onChange(o.value)}
				>
					{o.label}
				</button>
			))}
		</div>
	);
}
